import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MenuNotification, OperationType} from '@models/sidebar/menu-notification';

@Injectable({
  providedIn: 'root'
})
export class FavoriteNotificationService {

  private behaviourSubject = new BehaviorSubject(new MenuNotification(OperationType.NONE, '', '', ''));
  currentMenuNotification = this.behaviourSubject.asObservable();

  private pendingFavoriteNotifications: MenuNotification[] = [];

  broadcast(message: MenuNotification) {
    this.behaviourSubject.next(message);
  }

  public clearPendingFavoriteNotifications(): void {
    this.pendingFavoriteNotifications = [];
  }

  public getPendingFavoriteNotifications(): MenuNotification[] {
    return this.pendingFavoriteNotifications;
  }

  public addPendingFavoriteNotifications(menuNotification: MenuNotification): void {
    this.pendingFavoriteNotifications.push(menuNotification);
  }
}
